var jade = require("/opt/atlassian/pipelines/agent/build/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

var jade_indent = [];
buf.push("\n<form id=\"moveStopLocations\" ng-submit=\"moveStopLocations(multiMove.stops, multiMove.route.id)\" name=\"form\">\n  <button type=\"button\" ng-if=\"multiMove.close\" ng-click=\"multiMove.close()\" class=\"close\"></button>\n  <div ng-if=\"multiMove.oldRoute\" class=\"route-name color-{{ multiMove.oldRoute.color % routeColors.length }}\">{{ multiMove.oldRoute.name }}</div>\n  <div>{{ t('moveModalCustomersSelected', multiMove.customerCount()) }}</div>\n  <div class=\"select-route\">\n    <label>{{ t('moveModalMoveToRoute') }}</label>\n    <div class=\"select\">\n      <select ng-options=\"route as route.nameAndDriver(drivers, true) for route in routePlan.routes | filter: multiMove.routeFilter | orderBy: 'name'\" ng-model=\"multiMove.route\" ng-required=\"true\">\n        <option value=\"\">{{ t('moveModalMoveToRouteChoose') }}</option>\n      </select>\n    </div>\n  </div>\n  <div>\n    <div class=\"flex-padding\"></div>\n    <button type=\"submit\" ng-disabled=\"form.$invalid\" class=\"action\">{{ t('cSave') }}</button>\n  </div>\n</form>");;return buf.join("");
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/html/templates/moveStopLocations.jade
 ** module id = 24
 ** module chunks = 1
 **/